document.addEventListener('DOMContentLoaded', () => {
  let loading = false
  let flkty

  if (!customElements.get('free-gift-progress')) {
    customElements.define('free-gift-progress', class FreeGiftProgress extends HTMLElement {
      constructor () {
        super()

        this.progressSettings = JSON.parse(this.querySelector('#free-gift-tier-amount').innerHTML)

        this.cartTotalPrice = this.progressSettings.cartTotalPrice + this.progressSettings.thresholdAmount

        this.querySelectorAll('[data-tier-one]').forEach(item => {
          item.style.display = ['AUD', 'NZD'].includes(Shopify.currency.active) ? 'flex' : 'none'
        })

        if (this.querySelector('#free-gift-multiple-bar')) {
          this.onUpdateMultipleBar()
        } else {
          this.onUpdateOneBar()
        }
      }

      progressSettings = {}
      cartTotalPrice = 0

      onUpdateMultipleBar() {
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency

        let oneText = ''
        let oneWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          const oneAmount = this.progressSettings.tierOneAmount * rate

          if (this.querySelector('[for="tier-one-currency"]'))
            this.querySelector('[for="tier-one-currency"]').innerHTML = currency + (oneAmount / 100).toFixed(2)

          oneText = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          oneWidth = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * 100
        } else {
          oneText = this.progressSettings.tierOneFullfilText
          oneWidth = 100
        }
        if (this.querySelector('#tier-one-bar'))
          this.querySelector('#tier-one-bar').style.width = `${oneWidth}%`

        if (this.querySelector('#tier-one-fullfil-text') && oneWidth === 100) {
          this.querySelector('#tier-one-fullfil-text').innerHTML = oneText
        } else if (this.querySelector('#tier-one-text')) {
          this.querySelector('#tier-one-text').innerHTML = oneText
        }

        let twoText = ''
        let twoWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          const twoAmount = this.progressSettings.tierTwoAmount * rate

          if (this.querySelector('[for="tier-two-currency"]'))
            this.querySelector('[for="tier-two-currency"]').innerHTML = currency + (twoAmount / 100).toFixed(2)

          twoText = this.progressSettings.tierTwoText.replace('$money', currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2))
          twoWidth = this.cartTotalPrice / (this.progressSettings.tierTwoAmount * rate) * 100
        } else {
          twoText = this.progressSettings.tierTwoFullfilText
          twoWidth = 100
        }

        if (this.querySelector('#tier-two-bar'))
          this.querySelector('#tier-two-bar').style.width = `${twoWidth}%`

        if (this.querySelector('#tier-two-fullfil-text') && twoWidth === 100) {
          this.querySelector('#tier-two-fullfil-text').innerHTML = twoText
        } else if (this.querySelector('#tier-two-text')) {
          this.querySelector('#tier-two-text').innerHTML = twoText
        }

        let threeText = ''
        let threeWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          const threeAmount = this.progressSettings.tierThreeAmount * rate

          if (this.querySelector('[for="tier-three-currency"]'))
            this.querySelector('[for="tier-three-currency"]').innerHTML = currency + (threeAmount / 100).toFixed(2)

          threeText = this.progressSettings.tierThreeText.replace('$money', currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2))
          threeWidth = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        } else {
          threeText = this.progressSettings.tierThreeFullfilText
          threeWidth = 100
        }
        if (this.querySelector('#tier-three-bar'))
          this.querySelector('#tier-three-bar').style.width = `${threeWidth}%`

        if (this.querySelector('#tier-three-fullfil-text') && threeWidth === 100) {
          this.querySelector('#tier-three-fullfil-text').innerHTML = threeText
        } else if (this.querySelector('#tier-three-text')) {
          this.querySelector('#tier-three-text').innerHTML = threeText
        }
      }

      onUpdateOneBar() {
        let text = ''
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency
        let width = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100

        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          text = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))

        } else if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          this.querySelector('#one-bar-tier-one-title')?.classList.add('fullfil')
          text = this.progressSettings.tierTwoText.replace('$money', currency + ((this.progressSettings.tierTwoAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          this.querySelector('#one-bar-tier-one-title')?.classList.add('fullfil')
          this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          text = this.progressSettings.tierThreeText.replace('$money', currency + ((this.progressSettings.tierThreeAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else {
          text = this.progressSettings.tierThreeFullfilText
          this.querySelector('#one-bar-tier-one-title')?.classList.add('fullfil')
          this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          width = 100
        }

        if (this.querySelector('#one-bar-text')) {
          this.querySelector('#one-bar-text').innerHTML = text;
          this.querySelector('#one-bar-progress').style.width = `${width}%`;
        }
      }
    })
  }

  if (!customElements.get('free-gift-product')) {
    customElements.define('free-gift-product', class FreeGiftProduct extends HTMLElement {
      constructor() {
        super()
        this.rate = Number(window.Shopify.currency.rate)

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        this.cartTotalPrice = this.cartItems.total_price + Number(this.getAttribute('data-threshold-amount'))

        this.freeProductData = []
        this.querySelectorAll('.color-product script').forEach(item => {
          const product = JSON.parse(item.innerHTML)
          this.freeProductData = this.freeProductData.concat(product.variants)
        })
        if (!this.freeProductData.length)
          this.freeProductData = JSON.parse(this.querySelector('#free-product-variants').innerHTML)

        this.freeProductAmount = Number(this.getAttribute('data-free-number')) * this.rate


        const json = JSON.parse(this.querySelector('#free-product-json').innerHTML)
        this.freeGiftJson = json
        this.setText(json)

        if (this.freeGiftJson.variantType === 'select') {
          this.querySelector('.free-gift-select select')?.addEventListener('change', event => this.onVarBtnSelect(event))
        } else {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        }

        if (this.freeGiftJson.addToType === 'add-btn') {
          this.querySelector('.free-gift-product-buy').addEventListener('click', (event) => this.onAddBtnClick(event))
        }


        this.onCartUpdate()
      }

      rate = 0
      freeGiftJson = {}
      cartTotalPrice = 0
      cartItems = {}
      freeProductAmount = 0
      freeProductData = []
      hasFreeProductInCart = false

      setText(data) {
        const freeAmount = Number(data.freeAmount * this.rate)
        const currency = this.freeGiftJson.currency

        if (this.querySelector('#free-product-title'))
          this.querySelector('#free-product-title').innerHTML = data.freeProductTitle.replace('$money', currency + (freeAmount / 100).toFixed(2))

        if (freeAmount > this.cartItems.total_price) {
          const unlockAmount = (freeAmount - this.cartItems.total_price) / 100
          if (this.querySelector('#free-product-subtitle'))
            this.querySelector('#free-product-subtitle').innerHTML = data.freeProductSubtitle.replace('$money', currency + unlockAmount.toFixed(2))

          if (this.freeGiftJson.addToType === 'add-btn' && this.querySelector('#free-product-unlock'))
            this.querySelector('#free-product-unlock').innerHTML = data.freeUnlockText.replace('$money', currency + unlockAmount.toFixed(2))
        } else if (this.freeGiftJson.addToType === 'add-btn' && this.querySelector('#free-product-unlock')) {
            this.querySelector('#free-product-unlock').innerHTML = data.freeBtnFullfilText
        }
      }

      onVarBtnSelect(event) {
        if (loading) {
          return
        }

        if (this.freeGiftJson.addToType !== 'add-btn') {
          const id = event.target.value
          loading = true
          event.target.closest('div').classList.add('free-gift-loading')
          CartJS.addItem(id)
        }
      }

      onCartUpdate() {
        if (!this.freeProductData.length) {
          return
        }

        for (let i = 0; i < this.cartItems.items.length; i++) {
          const item = this.cartItems.items[i]
          for (const variant of this.freeProductData) {
            if (item.variant_id === variant.id && item.line_price === 0) {
              this.hasFreeProductInCart = true;
              this.freeProductIndex = i + 1
              break
            }
          }
        }

        // 如果购物车金额达到了free gift的金额
        if (this.cartTotalPrice >= this.freeProductAmount)   {
          // 如果购物车里面没有
          if (!this.hasFreeProductInCart) {
            // 如果只有一个variants
            if (this.freeProductData.length === 1 && this.freeGiftJson.addType === 'auto') {
              loading = true
              CartJS.addItem(this.freeProductData[0].id)
            } else {
              this.style.display = 'block'
              if (this.freeGiftJson.variantType !== 'select') {
                this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.classList.remove('disabled'))
                this.querySelectorAll('.color-product').forEach(item => item.classList.remove('disabled'))
              } else {
                this.querySelector('.free-gift-select')?.classList.remove('disabled')
                this.querySelectorAll('.color-product').forEach(item => item.classList.remove('disabled'))
              }

              if (this.freeGiftJson.addToType == 'add-btn') {
                this.querySelector('#free-product-btn').classList.remove('disabled')
                this.querySelectorAll('.color-product').forEach(item => item.classList.remove('disabled'))
              }
            }
          } else {
            this.style.display = 'none'
          }
        } else if(this.hasFreeProductInCart && this.freeProductAmount > this.cartTotalPrice) {
          this.style.display = 'block'
        } else {
          this.style.display = 'block'
        }
      }

      onAddBtnClick(event) {
        if (loading) {
          return
        }

        let id = ''
        if (this.freeGiftJson.variantType === 'select' && this.querySelector('select')) {
          id =  this.querySelector('select').value
        } else if (this.querySelectorAll('.free-gift-varitant-btn').length) {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
            if (item.classList.contains('selected')) {
              id = item.getAttribute('data-var-id')
            }
          })
        } else {
          id = this.querySelector('#free-product-btn').getAttribute('data-var-id')
        }

        event.target.closest('#free-product-btn').classList.add('free-gift-loading')

        loading = true
        if (id) {
          CartJS.addItem(id)
        } else {
          CartJS.addItem(event.target.getAttribute('data-var-id'))
        }
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
          item.classList.remove('selected')
        })
        this.querySelector('.free-gift-product-buy')?.classList.remove('disabled')

        event.target.classList.add('selected')


        if (this.freeGiftJson.addToType !== 'add-btn') {
          loading = true
          CartJS.addItem(event.target.getAttribute('data-var-id'))
          event.target.closest('.free-gift-varitant-btn').classList.add('free-gift-loading')
        }
      }
    })
  }

  if (!customElements.get('additional-products')) {
    customElements.define('additional-products', class AdditionalProducts extends HTMLElement {
      constructor() {
        super()

        this.freeGiftJson = JSON.parse(this.querySelector('#additional-product-json').innerHTML)

        if (this.freeGiftJson.variantType === 'btn')
          this.querySelectorAll('.additional-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else  {
          this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', (event) => {
            this.onVarBtnSelect(event)
          }))
        }

        if (this.querySelector('.add-btn')) {
          this.querySelectorAll('.add-btn').forEach(item => item.addEventListener('click', event => {
            let id = ''
            if (event.target.classList.contains('add-btn')) {
              event.target.classList.add('free-gift-loading')
              id = event.target.getAttribute('data-var-id')
            } else {
              event.target.parentNode.classList.add('free-gift-loading')
              id = event.target.parentNode.getAttribute('data-var-id')
            }

            loading = true
            CartJS.addItem(id)
          }))
        }

        this.onCartUpdate()

        if (document.querySelector('.main-carousel')) {
          flkty = new Flickity(document.querySelector('.main-carousel'), {
            cellAlign: 'left',
            prevNextButtons: false,
            contains: true,
            pageDots: false
          });
          flkty.resize()
        }
      }

      cartItems = {}
      freeGiftJson = {}

      onCartUpdate() {
        this.cartItems = JSON.parse(this.querySelector('#additional-cart-json').innerHTML)
        let count = 0
        this.querySelectorAll('.additional-product-card').forEach(card => {
          const id = Number(card.getAttribute('data-product-id'))
          if (!this.cartItems.items.find(item => item.product_id === id) && count < this.freeGiftJson.number) {
            card.style.display = 'flex'
            count += 1
          } else {
            card.style.display = 'none'
            card.parentNode.removeChild(card)
          }
        })
        if (count === 0) {
          this.style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading){
          return
        }

        const id = event.target.getAttribute('data-var-id')
        // event.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none'
        loading = true
        CartJS.addItem(id)
        event.target.closest('.additional-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
      constructor() {
        super()

        this.variantType = this.getAttribute('data-variant-type')
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.variantType === 'btn')
          this.querySelectorAll('.upsell-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else
          this.querySelector('.free-gift-select select')?.addEventListener('change', (event) => this.onVarBtnSelect(event))


        this.querySelector('.add-btn')?.addEventListener('click', event => {
          let id = ''
          if (event.target.classList.contains('add-btn')) {
            event.target.classList.add('free-gift-loading')
            id = event.target.getAttribute('data-var-id')
          } else {
            event.target.parentNode.classList.add('free-gift-loading')
            id = event.target.parentNode.getAttribute('data-var-id')
          }

          loading = true
          CartJS.addItem(id)
        })

        this.querySelector('.upsell-item-close')?.addEventListener('click', () => {
          this.style.display = 'none'
        })

        this.onCartUpdate()
      }

      cartItems = {}
      addToType = ''
      variantType = ''

      onCartUpdate() {
        if (!this.cartItems.items.find(item => item.product_id === Number(this.getAttribute('data-product-id'))) && !localStorage.getItem(`upsell-hide-${this.getAttribute('data-product-id')}-${this.getAttribute('data-cart-id')}`)) {
          this.querySelector('.product-card').style.display = 'flex'
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
          this.querySelector('.product-card').style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading){
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.upsell-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  $(document).on('cart.requestComplete', (event, cart) => {
    loading = false
  })

  if (!customElements.get('color-product')) {
    customElements.define('color-product', class ColorProduct extends HTMLElement {
      constructor() {
        super()

        this.querySelectorAll('.color-product').forEach(item => item.addEventListener('click', event => this.onProductClick(event)))
      }

      onProductClick(event) {
        if (event.target.classList.contains('active') || event.target.classList.contains('disabled')) {
          return
        }

        this.querySelectorAll('.color-product').forEach(item => item.classList.remove('active'))

        event.target.classList.add('active')

        const json = JSON.parse(event.target.querySelector('script').innerHTML)

        const card = document.querySelector('.free-gift-product-wrapper-product-card')
        card.querySelector('img').src = json.featured_image
        card.querySelector('.product-title').innerHTML = `<strong>FREE</strong> ${json.title}`
        card.querySelector('#free-product-btn').setAttribute('data-var-id', json.variants[0].id)

        document.querySelector('size-select').giftJson = json
        document.querySelector('size-select').insertSizeSelectHtml()
      }
    })
  }

  if (!customElements.get('size-select')) {
    customElements.define('size-select', class SizeSelect extends HTMLElement {
      constructor() {
        super();
        setTimeout(() => {
          this.giftJson.variants = JSON.parse(this.querySelector('script').innerHTML)
          this.setUpSizeClick()
        }, 100)
      }

      giftJson = {}

      insertSizeSelectHtml() {
        this.querySelector('.size-select-div').innerHTML = this.buildSizeHtml(this.giftJson.variants)
        setTimeout(() => {
          this.setUpSizeClick()
        }, 10)
      }

      buildSizeHtml(options) {
        return options.map((item, index) => `<div data-index="${index}" class="div ${index === 0 ? 'active' : ''}">${item.option1}</div>`).join('')
      }

      setUpSizeClick() {
        this.querySelectorAll('.size-select-div .div').forEach((item, index) => {
          if (index === 0) {
            item.classList.add('active')
            this.setProductAddBtn(Number(item.getAttribute('data-index')))
          }

          item.addEventListener('click', event => {
            this.querySelectorAll('.size-select-div div').forEach(sub => sub.classList.remove('active'))
            event.target.classList.add('active')
            this.setProductAddBtn(Number(event.target.getAttribute('data-index')))
          })
        })
      }

      setProductAddBtn(index) {
        document.querySelector('#free-product-btn')
          ?.setAttribute('data-var-id', this.giftJson.variants[index].id)
      }

    })
  }

  if (!customElements.get('minicart-header')) {
    customElements.define('minicart-header', class MiniCartHeader extends HTMLElement {
      constructor() {
        super()
        this.querySelector('.close-cart').addEventListener('click', () => {
          document.body.classList.remove('mini-cart')
        })
      }
    })
  }
})
